import { SilentError } from './SilentError';

/**
 * Any core functionality-related error
 */
export class CoreWarning extends SilentError {
    _reason;
    /**
     * @param {string} [message]
     * @param {null | Error | string | Record<string, any>} [reason]
     * @constructs CoreError
     */
    constructor(message, { reason } = {}) {
        super(message);
        this.name = 'CoreWarning';
        this._reason = reason;
    }

    /**
     *
     * @return {*}
     */
    get reason() {
        return this._reason;
    }
}
